@if (isMobile()) {
  <shared-ui-menu-radio
    [title]="title()"
    [isRadioInline]="isRadioInline()"
    [value]="value()"
    [isMobile]="isMobile()"
    [items]="items()"
    (dialogConfirm)="onDialogConfirm($event)"
    [isDisabled]="items()?.length === 0 || isDisabled()"
    [buttonClass]="buttonClass()"
    [dialogTitle]="dialogTitle()"
  >
    <ng-container button *ngTemplateOutlet="button"></ng-container>
    <ng-container header *ngTemplateOutlet="header"></ng-container>
    <ng-container footer *ngTemplateOutlet="footer"></ng-container>
  </shared-ui-menu-radio>
} @else {
  <shared-ui-menu
    [buttonClass]="buttonClass()"
    [menuClass]="menuClass()"
    [isInline]="isInline()"
    [title]="title()"
    [placeholder]="placeholder()"
    [height]="height()"
    [maxHeight]="maxHeight()"
    [isDisabled]="items()?.length === 0 || isDisabled()"
    [dialogTitle]="dialogTitle()"
    [extraTitle]="extraTitle()"
  >
    <ng-container button *ngTemplateOutlet="button"></ng-container>

    <ng-container header *ngTemplateOutlet="header"></ng-container>

    @for (item of viewItems(); track item.title) {
      <div
        class="menu-item {{ menuItemClass() }}"
        [class.justify-between]="item.checked && isCheckSelectedItem()"
        (click)="onMenuItemTriggered(item)"
      >
        <span
          class="menu-item-text text-overflowing"
          [class.selected]="item.checked"
          >{{ item.title || '—' }}</span
        >

        @if (item.checked && isCheckSelectedItem()) {
          <svg class="fill-primary-500 h-[9px] w-[10px]">
            <use xlink:href="#checked"></use>
          </svg>
        }
      </div>
    }

    <ng-container footer *ngTemplateOutlet="footer"></ng-container>
  </shared-ui-menu>
}

<ng-template #button>
  <ng-content select="[button]"></ng-content>
</ng-template>

<ng-template #header>
  <ng-content select="[header]"></ng-content>
</ng-template>

<ng-template #footer>
  <ng-content select="[footer]"></ng-content>
</ng-template>
